// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@awc/XDL/Utilities";
import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalContent: css`
            padding: 20px 15px;
            ${xScreen("gte", "sm")} {
                overflow-y: visible;
            }
        `,
        modalBody: css`
            ${xScreen("gte", "sm")} {
                overflow: visible;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};

scheduleReminderModalStyles.titleText = {
    variant: "h4",
    css: css`
        &&& {
            margin-bottom: 0;
        }
    `,
};

scheduleReminderModalStyles.hintText = {
    size: 15,
    css: css`
        margin-top: 5px;
    `,
};

scheduleReminderModalStyles.startDateGridItem = scheduleReminderModalStyles.endDateGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        & > div {
            display: flex;
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        inputSelect: css`
            width: max-content;
        `,
        formInputWrapper: css`
            width: 100%;
        `,
        datePicker: css`
            .react-datetime-picker {
                width: 100%;
            }

            .react-calendar {
                width: 100%;
                min-width: 280px;
            }
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = scheduleReminderModalStyles.startDatePicker;

scheduleReminderModalStyles.middleRowLeftColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.frequencyRadioGroup = {
    horizontal: true,
    css: css`
        &&& {
            legend {
                margin-bottom: 10px;
            }
        }
    `,
};

scheduleReminderModalStyles.weeklyRadio = {};

scheduleReminderModalStyles.monthlyRadio = {};

scheduleReminderModalStyles.bottomRowGridItem = {
    width: 12,
};

scheduleReminderModalStyles.buttonsContainer = {
    gap: 0,
    css: css`
        & ${GridOffset} {
            flex-wrap: wrap;
            justify-content: flex-end;
        }
    `,
};

scheduleReminderModalStyles.stopButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        order: 2;
        &&& {
            margin-left: 10px;
            ${xScreen("lte", "xs")} {
                width: 100%;
                margin-left: 0;
                margin-bottom: 10px;
                order: -1;
            }
        }
    `,
};

scheduleReminderModalStyles.cancelButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        &&& {
            margin-right: 10px;
        }
        ${xScreen("lte", "xs")} {
            &&& {
                order: 1;
                width: 100%;
                margin-right: 0;
                margin-top: 10px;
            }
        }
    `,
};

scheduleReminderModalStyles.scheduleButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.contentContainer = {
    gap: 0,
    offsetCss: css`
        gap: 22px;
    `,
};

scheduleReminderModalStyles.middleRowContainer = {
    gap: 0,
    offsetCss: css`
        gap: 12px;
    `,
};

scheduleReminderModalStyles.leftColumnContainer = {
    gap: 12,
};

scheduleReminderModalStyles.cancelButtonsGridItem = modalButtonsActionStyles.buttonsGridItem;

scheduleReminderModalStyles.dismissCancelButton = scheduleReminderModalStyles.cancelButton = {
    ...mergeWithCss(modalButtonsActionStyles.cancelButton, {
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};

scheduleReminderModalStyles.confirmCancelButton = scheduleReminderModalStyles.scheduleButton = {
    ...mergeWithCss(modalButtonsActionStyles.submitButton, {
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};
